import { useSelector } from 'react-redux';
import { PinPointIcon } from '../../../../utils/svg';
import ImageLoader from '../../ImageLoader';
import { checkHoldTime, checkTime, isEmptyData } from '../../../../utils/helper';
import { ClockIcon } from '@heroicons/react/24/solid';
import location from '../../../../common/images/revamp/icon/location.svg';
import Info from '../Info';
import { useState } from 'react';
import { BottomSheet } from 'react-spring-bottom-sheet';

const OtherLocation = ({ onSelect }) => {
	const { outletByLocation } = useSelector((store) => store?.outlet);
	const [isShowBottomSheet, setIsShowBottomSheet] = useState(false);
	const [selectedOutlet, setSelectedOutlet] = useState(null);

	const handleClickOutletInfo = (outlet) => {
		setSelectedOutlet(outlet);
		setIsShowBottomSheet(true);
	};

	const handleCloseBottomSheet = () => {
		setIsShowBottomSheet(false);
		setSelectedOutlet(null);
	};

	const infoProps = {
		outlet: selectedOutlet,
	};

	return (
		<>
			<div className='m-4 !z-[7]'>
				<div className='font-semibold text-base text-gray-700 mb-4'>Choose Outlet</div>
				{outletByLocation?.map((item, index) => {
					const isBusy = item?.endHold && checkHoldTime(item?.endHold);
					const outletStatus = isBusy ? `Resto sedang sibuk` : `Tutup${item?.outletOpenTime ? ` - Buka pukul ${item?.outletOpenTime} ${checkTime(item?.outletOpenTime)} hari ini` : ''}`;
					const distance = parseFloat(item?.distance || 0)?.toFixed('2');
					return (
						<div
							key={index}
							className={`flex gap-1 flex-col py-[14px] border-b border-solid border-b-steam last:border-b-0 ${item?.storeOpen === '1' && 'pointer'}`}
							onClick={() => {
								if (item?.outOfDelivery || item?.storeOpen === '0') return;
								onSelect(item);
							}}>
							<div className={`${item?.storeOpen === '0' ? 'flex' : 'hidden'} items-center`}>
								<ClockIcon class='h-4 w-4 text-red-500 mr-1' />
								<div className='text-xxs font-medium text-gray-900'>{outletStatus}</div>
							</div>
							<div className={`${item?.outOfDelivery && item?.storeOpen === '1' ? 'flex' : 'hidden'} items-center`}>
								<PinPointIcon className={'stroke-red-500 text-red-500 fill-red-500 mr-1'} />
								<div className='text-xxs font-medium text-orange-700'>Diluar Jangkauan Pengiriman</div>
							</div>
							<div className='flex gap-3'>
								<ImageLoader src={item?.storeImage} alt={item?.storeImage} className='rounded-lg w-6 h-6 object-cover object-center mt-1' />
								<div className='grow space-y-1'>
									<p className='mb-0 font-medium text-[var(--dark-gray)] line-clamp-1 max-w-[calc(100vw-68px)] text-sm !mt-0'>{item?.storeName}</p>
									<div className='flex gap-2'>
										<div className='flex items-center gap-1'>
											<img src={location} alt='location' />
											<span className='text-xxs font-normal'>{distance} km</span>
										</div>
										<div
											className='flex items-center gap-1'
											onClick={(e) => {
												e.stopPropagation();
												console.log('click outlet info');
												handleClickOutletInfo(item);
											}}>
											<span className='text-xxs font-normal text-blue-500'>Outlet Info</span>
										</div>
									</div>
									<p className='mb-0 text-[var(--dark-gray)] line-clamp-1 max-w-[calc(100vw-68px)] text-xxs font-normal'>{item?.storeAddress}</p>
								</div>
							</div>
						</div>
					);
				})}
			</div>
			<BottomSheet
				key={'OutletInfo'}
				open={isShowBottomSheet}
				onDismiss={handleCloseBottomSheet}
				snapPoints={({ minHeight, maxHeight }) => {
					return [minHeight, maxHeight * 0.75];
				}}>
				<Info {...infoProps} />
			</BottomSheet>
		</>
	);
};

export default OtherLocation;
